/** What registers answer when they have nothing: "N/A", "n.a.", "---". */
const PLACEHOLDER = /^(-+|n\/?a|n\.a\.?)$/i;

/**
 * The value a form field should hold after a late register answer: whatever
 * is already there, or else the answer when it is a real value.
 */
export function fillIfEmpty(current: string, incoming: unknown): string {
  if (current.trim() !== "") return current;
  if (incoming == null) return current;

  const text = String(incoming).trim();
  if (text === "" || PLACEHOLDER.test(text)) return current;
  return text;
}
